export const COMPANY_OPTIONS = [
  "Fraport",
  "AirIT",
  "ACS (Airport Cater Service)",
  "ASG (Airport Service Gesellschaft)",
  "FRA – Vorfeldkontrolle",
  "FraAlliance",
  "FCS (FraCareServices)",
  "FAR (Frankfurt Airport Retail)",
  "FAS (Frankfurt Ausbau Süd)",
  "FFS (Frankfurt Facility Services)",
  "FGS (Frankfurt Ground Services)",
  "Fraport Immobilienservice",
  "FPS (Frankfurt Passenger Services)",
  "Media Frankfurt",
  "Medical Airport Services",
  "NICE",
  "AHS",
  "Global",
  "DHS",
  "Swissport",
  "WISAG",
  "Rentner",
  "Cathay Pacific",
  "China Airlines",
  "China Eastern Airlines",
  "China Southern Airlines",
  "Emirates",
  "Etihad Airways",
  "Gulf Air",
  "Korean Air",
  "Kuwait Airways",
  "Oman Air",
  "Qatar Airways",
  "Saudia",
  "Tway",
  "Air Algérie",
  "Air Astana",
  "Air Cairo",
  "Air Montenegro",
  "Air Serbia",
  "FlyErbil",
  "MEA Middle East Airlines",
  "Nesma Airlines",
  "Nouvelair",
  "Royal Air Maroc",
  "Royal Jordanian Airlines",
  "Star East Airlines",
  "Tunisair",
  "Turkmenistan Airlines",
  "Uzbekistan Airways",
  "Aer Lingus",
  "Air Anka",
  "American Airlines",
  "British Airways",
  "Corendon Airlines Europe",
  "Delta",
  "European Air Charter",
  "Freebird Airlines Europe",
  "HiSky Europe",
  "JAL Japan Airlines",
  "MIAT Mongolian Airlines",
  "Pegasus Airlines",
  "SriLankan Airlines",
  "TUI fly",
  "Vietnam Airlines",
  "Air Europa",
  "Air France",
  "airBaltic",
  "Bulgaria Air",
  "easyJet",
  "Finnair",
  "Iberia",
  "Icelandair",
  "KLM Royal Dutch Airl.",
  "SAS Scandinavian Airl.",
  "SATA Azores Airlines",
  "SKY express",
  "TAROM",
  "Electra Airways",
  "Iraqi Airways",
  "SmartLynx Airlines",
  "Enter Air",
  "FlyEgypt",
  "MGA Mavigok Aviation",
  "Sundair",
  "Smart Wings",
  "Iran Air",
  "Sky Up"
] as const;

export type Company = typeof COMPANY_OPTIONS[number];